import Vue from 'vue';
import VueI18n from 'vue-i18n';
import enLocale from 'element-ui/lib/locale/lang/en';
import zhLocale from 'element-ui/lib/locale/lang/zh-CN';
import Element from 'element-ui';
// import ElementLocale from 'element-ui/lib/locale';
import zh from './zh.json';
import en from './en.json';
import store from '../store/index.js';
console.log(store, 'store');
Vue.use(VueI18n);

const locales = {
    zh: Object.assign(zh, zhLocale),
    en: Object.assign(en, enLocale),
};

const i18n = new VueI18n({
    locale: store?.state?.language || 'zh',
    messages: locales,
});
Vue.use(Element, {
    i18n: (key, value) => i18n.t(key, value),
});
//ElementLocale.i18n((key, value) => i18n.t(key, value));
export default i18n;
